import {
  alpha,
  makeStyles,
  LinearProgress as Progress,
  LinearProgressProps as ProgressProps,
} from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';

export type LinearProgressProps = Omit<ProgressProps, 'color'> & {
  color: string;
  orientation?: 'vertical' | 'horizontal';
};

const useStyles = makeStyles({
  root: { height: 6, borderRadius: 2 },
  colorPrimary: (p: LinearProgressProps) => ({
    backgroundColor: alpha(p.color, 0.4),
  }),
  barColorPrimary: (p: LinearProgressProps) => ({
    backgroundColor: p.color,
  }),
});

const LinearProgress: React.FC<LinearProgressProps> = ({
  variant = 'determinate',
  orientation = 'horizontal',
  color,
  ...props
}) => {
  const progressRef = useRef(null);
  const [parentHeight, setParentHeight] = useState(0);

  const classes = useStyles({ color } as LinearProgressProps);

  useEffect(() => {
    if (orientation === 'vertical' && progressRef.current) {
      const { parentElement } = progressRef.current as HTMLDivElement;
      const height = parentElement?.clientHeight ?? 50;
      setParentHeight(height);
    }
  }, [orientation]);

  return (
    <div
      ref={progressRef}
      style={{
        width: 'inherit',
        position: 'relative',
        height: orientation === 'vertical' ? parentHeight : 'auto',
      }}
    >
      <Progress
        variant={variant}
        classes={{
          root: classes.root,
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
        style={{
          ...(orientation === 'vertical'
            ? {
                width: parentHeight,
                transform: 'rotate(-90deg)',
                transformOrigin: 'top right',
                position: 'absolute',
                top: 0,
                right: 4,
              }
            : {
                width: '100%',
              }),
        }}
        {...props}
      />
    </div>
  );
};

export default LinearProgress;
